import restApi from "@plannel/services/utils/rest-api";

/*
 * Location Inventory Status(거점별 재고 현황 — RP 보충계획 관점) 데이터 서비스.
 * 독립 DW 기반 백엔드 조회 — **목업 없음, 전부 실데이터**.
 *   백엔드: GET /api/dashboard-dw/location-inventory (LocationInventoryDashboardController)
 *   소스: z_fact_rp_replenishment ⋈ z_location(좌표·유형) ⋈ z_bod/z_bod_item(lane 리드타임)
 *   산식·컬럼 명세: saas-application/docs/sql/dw/dashboard-spec/05_location_inventory.md
 *
 * params: { currentDate?, itemLevel?, locType? }
 *   ★ 단위(AMT/QTY)도 버킷(일/주/월)도 거점 선택도 **재조회 대상이 아니다** — 응답이 조합을 다 담고 있다.
 *   ★ 계획 버전 필터는 없다 — RP fact 은 rolling 적재라 구간이 겹치지 않는다(명세 §0).
 *
 * 응답 envelope: { currencyCd, baseMonth, period, availableBuckets, bucketUnit,
 *                  itemLevels, itemLevel, locTypes, kpis, spark,
 *                  network:{nodes,originNodes,links}, locationRows[],
 *                  psiBalance:{[버킷]:{[거점|all]:[...]}}, exceptionRows:{shortage[],excess[]} }
 *
 * 🚨 조회 시 (base_date, dest_loc_id, item_id, currency_cd) 로 **접어야** 한다 —
 *    multi-sourcing 이면 dest 레벨 값이 origin 행마다 복제된다(명세 §4-1). 진단: tools/3_check_rp_grain.sql
 */
const get = (params) => restApi.get("/api/dashboard-dw/location-inventory", { params });

const locationInventoryService = { get };

export default locationInventoryService;
